import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';

export const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <>
            <SEOHead seo={{
                title: '404 — Page Not Found | Arte Craft India',
                description: 'The page you are looking for does not exist.',
                canonical: `${window.location.origin}/404`,
                noIndex: true,
            }} />

            <div style={{
                minHeight: '72vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '80px 20px',
                background: '#f5f8fc',
            }}>
                {/* Big code */}
                <div style={{
                    fontSize: '7rem',
                    fontWeight: 900,
                    lineHeight: 1,
                    background: 'linear-gradient(135deg, #1E3A5F 0%, #2E75B6 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    letterSpacing: '-0.04em',
                }}>
                    404
                </div>

                {/* Divider */}
                <div style={{
                    width: 60,
                    height: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(90deg, #1E3A5F, #2E75B6)',
                    margin: '18px 0',
                }} />

                <h1 style={{
                    fontSize: '1.5rem',
                    fontWeight: 800,
                    color: '#1a202c',
                    margin: '0 0 10px',
                    textAlign: 'center',
                }}>
                    Page Not Found
                </h1>

                <p style={{
                    fontSize: '0.95rem',
                    color: '#64748b',
                    margin: '0 0 36px',
                    textAlign: 'center',
                    maxWidth: 380,
                    lineHeight: 1.6,
                }}>
                    The page you're looking for doesn't exist or may have been moved.
                </p>

                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            padding: '10px 24px',
                            borderRadius: 8,
                            border: '1.5px solid #cbd5e1',
                            background: '#fff',
                            color: '#1E3A5F',
                            fontWeight: 700,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                        }}
                    >
                        Go Back
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            padding: '10px 24px',
                            borderRadius: 8,
                            border: 'none',
                            background: 'linear-gradient(135deg, #1E3A5F 0%, #2E75B6 100%)',
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                        }}
                    >
                        Go to Home
                    </button>
                </div>
            </div>
        </>
    );
};
